import React from "react";
import { Card } from "@/components/ui/card";

export const Settings = () => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-semibold">System Settings</h1>
      </div>

      <Card className="p-6">
        <div className="space-y-4">
          <div>
            <h2 className="text-xl font-medium">General Settings</h2>
            <p className="text-sm text-muted-foreground">
              Configure system-wide settings and defaults
            </p>
          </div>

          <div className="py-4 text-center text-muted-foreground">
            Settings configuration will be implemented in a future update.
          </div>
        </div>
      </Card>
    </div>
  );
};
